


























































































































































// TODO: Enable lint.
/* eslint-disable */
import { defineComponent, onMounted, reactive, SetupContext } from '@vue/composition-api';

import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

import moment from 'moment'

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: "Item",
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/style.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/item.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" }
    ]
  },
  filters: {
    moment: function (date: string) {
      moment.lang('ja')
      return moment(date).format('YYYY/MM/DD HH:mm')
    }
  },

  setup(_, context: SetupContext) {
    console.log("Setup!!!");

    const state = reactive({
      images: [],
    });

    async function listImages() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      }

      API.get('dev', '/images/products', options).then(response => {
        state.images = (response.data === null) ? [] : response.data;
      }).catch(err => {
        console.log(err);
      });
    }
    listImages();
    console.log("Loaded!!!");

    onMounted(() => {
      console.log('ImageItem onMounted!!');
    });

    return {
      state
    };
  }

});
